import React from 'react';
import Bodenfeuchte from '../components/Bodenfeuchte';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodenfeuchteMuerzzuschlag() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodenfeuchte-muerzzuschlag-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodenfeuchte-muerzzuschlag-heading">BODENFEUCHTE</h1>
        </div>

        <Bodenfeuchte ort="muerzzuschlag" />
      </div>
    </div>
  );
}

export default BodenfeuchteMuerzzuschlag;
